import { Link } from 'react-router-dom'

// ** MUI Components
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import MuiCard from '@mui/material/Card'
import { styled, useTheme } from '@mui/material/styles'
import AuthIllustrationV1Wrapper from '../login/AuthIllustrationV1Wrapper.js'
import BlankLayout from '../../Layout/blankLayout.js'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import axios from 'axios'
import useAuth from '../../../hooks/useAuth.js'
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

import { dev_baseUrl } from "../../../utils/var";
// ** Custom Components Imports
import Icon from '../../../components/icon'
import CustomTextField from '../../../components/mui/text-field'

// ** Styled Components
const Card = styled(MuiCard)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { width: '25rem' }
}))

const LinkStyled = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  justifyContent: 'center',
  color: theme.palette.primary.main,
  fontSize: theme.typography.body1.fontSize
}))

const ForgotPassword = () => {
  // const theme = useTheme()

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { login, logout } = useAuth();

  useEffect(() => {
    logout();
  }, []);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timer = setTimeout(() => {
        
        setErrors({});
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [errors]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setError('');
    const newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      newErrors.email = 'Please enter a valid email format.';       
    }     
    if(!email){
      newErrors.email = "Please enter a valid email address.";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    
    setLoading(true);
        
    try {
      const response = await axios.post(`${dev_baseUrl}/Account/resetpassword`, {
        email: email,
        resetCode: "",
        newPassword: ""
      });

      if (!response.data.isError) {
        navigate('/reset-link', { state: { email: email } });
      } else {
        setErrors({message: response.data.message});
      }
    } catch (err) {
      setErrors({message: 'An error occurred. Please try again.'});
    } finally {
        setLoading(false);
    }
  };

  const handleReturn = () => {
    navigate('/login')
  }

  // const handleChange = prop => event => {

  //     setValues({ ...values, [prop]: event.target.value });
  //     setErrors({ ...errors, [prop]: '' });
    
  // };


  return (
    <BlankLayout>
      <Box className='content-center'>
        <AuthIllustrationV1Wrapper>
          <Card variant='outlined'>
            <CardContent sx={{ p: theme => `${theme.spacing(10.5, 8, 8)} !important` }}>
              <Box sx={{ mb: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img height='50' alt='error-illustration' src='/images/Logo2.svg' />
              </Box>
              <Box sx={{ mb: 6, textAlign: 'center' }}>
                <Typography variant='h4' sx={{ mb: 1.5 }}>
                  Reset Password
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Enter the email address associated with your account and we'll send you a link to reset your password.
                </Typography>
              </Box>
              <form noValidate autoComplete='off' onSubmit={handleSubmit}>
                <CustomTextField
                  autoFocus
                  fullWidth
                  id='email'
                  label='Email'
                  sx={{ mb: 4 }}
                  placeholder='example@gmail.com'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  // onChange={handleChange('email')}
                  error={!!errors.email}
                  helperText={errors.email}
                />
                {errors && <Typography color='error' sx={{ mb: 2 }}>{errors.message}</Typography>}
                <Button disabled={loading} fullWidth type='submit' variant='contained' color='main' sx={{ mb: 4 }}>                
                  Reset Password
                </Button>
                {/* <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}> */}
                  {/* <Typography onClick={handleReturn} sx={linkStyles()}>
                    Return to Log in
                  </Typography> */}
                  <Typography onClick={handleReturn} sx={{ display: loading ? 'none' : 'flex', alignItems: 'center', justifyContent: 'center', '& svg': { mr: 1 } }}>
                    <LinkStyled>
                      <Icon fontSize='1.25rem' icon='tabler:chevron-left' />
                      <span>Return to Log in</span>
                    </LinkStyled>
                  </Typography>
                {/* </Box> */}
              </form>
            </CardContent>
          </Card>
        </AuthIllustrationV1Wrapper>
      </Box>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </BlankLayout>
  )
}

export default ForgotPassword
